"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _slateIconHeader = require("@canner/slate-icon-header");

var _slateIconShared = require("@canner/slate-icon-shared");

var _getSelectionRange = require("get-selection-range");

var _container = require("./container");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defaultPlugins = [(0, _slateIconShared.ParagraphPlugin)(), (0, _slateIconHeader.HeaderOnePlugin)(), (0, _slateIconHeader.HeaderTwoPlugin)()];

var _default = function _default() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$icons = options.icons,
      icons = _options$icons === void 0 ? [{
    icon: _slateIconHeader.Header1,
    title: "Header One"
  }, {
    icon: _slateIconHeader.Header2,
    title: "Header Two"
  }] : _options$icons,
      _options$leftOffset = options.leftOffset,
      leftOffset = _options$leftOffset === void 0 ? -20 : _options$leftOffset;
  var i = 0;
  return function (Editor) {
    var Sidebar =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(Sidebar, _React$Component);

      function Sidebar(props) {
        var _this;

        _classCallCheck(this, Sidebar);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(Sidebar).call(this, props));

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "sidebarContainerNode", void 0);

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "containerNode", void 0);

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hidePopover", function () {
          _this.setState({
            openPopover: false
          });
        });

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleVisibleChange", function (visible) {
          _this.setState({
            openPopover: visible
          });
        });

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderButton", function (Type, title) {
          var _this$props = _this.props,
              value = _this$props.value,
              onChange = _this$props.onChange;
          return React.createElement(_container.IconContainer, {
            key: i++
          }, React.createElement(_container.IconWrapper, null, React.createElement(Type, {
            change: value.change(),
            onChange: onChange,
            className: "__slate-sidebar_slateToolbarItem",
            strokeClassName: "qlStroke",
            strokeMitterClassName: "qlStrokeMitter",
            fillClassName: "qlFill",
            evenClassName: "qlEven",
            colorLabelClassName: "qlColorLabel",
            thinClassName: "qlThin",
            activeStrokeMitterClassName: "qlStrokeMitterActive",
            activeClassName: "__slate-sidebar_slateToolbarItem __slate-sidebar_slateToolbarActiveItem",
            activeStrokeClassName: "qlStrokeActive",
            activeFillClassName: "qlFillActive",
            activeThinClassName: "qlThinActive",
            activeEvenClassName: "qlEvenActive"
          })), React.createElement("div", null, title));
        });

        _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderSidebar", function () {
          var value = _this.props.value;
          var openPopover = _this.state.openPopover;
          var texts = value.texts,
              focusBlock = value.focusBlock;
          var currentTextNode = texts.get(0);
          var currentLineText = currentTextNode.text;
          var content = icons.map(function (item) {
            return _this.renderButton(item.icon, item.title);
          });
          return currentLineText.length === 0 && focusBlock.type === "paragraph" && React.createElement(_container.SidebarContainer, {
            innerRef: function innerRef(node) {
              return _this.sidebarContainerNode = node;
            }
          }, React.createElement(_antd.Icon, {
            type: "plus-circle",
            theme: "outlined",
            onClick: function onClick() {
              return _this.handleVisibleChange(!openPopover);
            },
            className: openPopover && "open"
          }), React.createElement(_container.PopupContainer, {
            isOpen: openPopover
          }, content));
        });

        _this.state = {
          openPopover: false
        };
        return _this;
      }

      _createClass(Sidebar, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          window.addEventListener("scroll", function () {
            return _this2.componentDidUpdate(_this2.props);
          });
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          var _this3 = this;

          window.removeEventListener("scroll", function () {
            return _this3.componentDidUpdate(_this3.props);
          });
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var value = this.props.value;
          var texts = value.texts,
              focusBlock = value.focusBlock;
          var currentTextNode = texts.get(0);
          var currentLineText = currentTextNode.text;

          if ((currentLineText.length !== 0 || focusBlock.type !== "paragraph" || this.props.value !== prevProps.value) && this.state.openPopover) {
            this.hidePopover();
          }

          var rect = (0, _getSelectionRange.getVisibleSelectionRect)();

          if (!rect || !this.sidebarContainerNode || !this.containerNode) {
            return;
          }

          var containerBound = this.containerNode.getBoundingClientRect();
          var containerBoundTop = containerBound.top;
          this.sidebarContainerNode.style.left = "".concat(leftOffset, "px");
          var top = rect.top - containerBoundTop - 3;
          this.sidebarContainerNode.style.top = "".concat(top, "px");
          this.sidebarContainerNode.style.opacity = "1";
        }
      }, {
        key: "render",
        value: function render() {
          var _this4 = this;

          return React.createElement("div", {
            style: {
              position: "relative"
            },
            ref: function ref(node) {
              return _this4.containerNode = node;
            }
          }, this.renderSidebar(), React.createElement(Editor, this.props));
        }
      }]);

      return Sidebar;
    }(React.Component);

    return (
      /*#__PURE__*/
      function (_React$Component2) {
        _inherits(SlateSidebarDecorator, _React$Component2);

        function SlateSidebarDecorator() {
          _classCallCheck(this, SlateSidebarDecorator);

          return _possibleConstructorReturn(this, _getPrototypeOf(SlateSidebarDecorator).apply(this, arguments));
        }

        _createClass(SlateSidebarDecorator, [{
          key: "render",
          value: function render() {
            return React.createElement(Sidebar, _extends({}, this.props, {
              plugins: this.props.plugins || defaultPlugins
            }));
          }
        }]);

        return SlateSidebarDecorator;
      }(React.Component)
    );
  };
};

exports.default = _default;